import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

// Super Admin pages
import SuperAdminLogin from '@pages/super-admin/Login'
import Dashboard from '@pages/super-admin/Dashboard'
import ClientManagement from '@pages/super-admin/ClientManagement'
import DomainManagement from '@pages/super-admin/DomainManagement'
import NotFoundPage from '@pages/common/NotFoundPage'

// Components
import SuperAdminLayout from '@components/super-admin/SuperAdminLayout'
import ProtectedRoute from '@components/super-admin/ProtectedRoute'

// Context
import { SuperAdminAuthProvider } from '@contexts/SuperAdminAuthContext'

const SuperAdminRoutes = () => {
  return (
    <SuperAdminAuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<SuperAdminLogin />} />
        
        {/* Protected routes with layout */}
        <Route path="/" element={
          <ProtectedRoute>
            <SuperAdminLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="clients" element={<ClientManagement />} />
          <Route path="domains" element={<DomainManagement />} />
        </Route>
        
        {/* Catch-all route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </SuperAdminAuthProvider>
  )
}

export default SuperAdminRoutes